/**
 * 获取图片尺寸 - 同步
 * @param url
 * @param callback
 */
export const getImageSizeByUrl = async (url: string, callback?: (width: number, height: number) => void) => {
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.src = url;

  img.onload = function () {
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    callback?.(width, height);
    return { width, height };
  };

  img.onerror = function () {
    console.error('Error loading image');
    callback?.(0, 0);
    return { width: 0, height: 0 };
  };
};

/**
 * 获取图片尺寸 - 异步
 * @param imageUrl
 * @returns
 */
export const getImageSizeAsync: (imageUrl: string) =>
Promise<{ width: number, height: number }> = (imageUrl: string) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    resolve({ width: img.width, height: img.height });
  };
  img.onerror = () => {
    resolve({ width: 0, height: 0 });
  };
  img.src = imageUrl;
});
